import { isEqual } from 'lodash-es';

import { SearchQuery } from '~/features/advanced-search/types';
import { mapTableColumnConfig } from '~/redux/api/methods/sylvanus/transformers';

import { ModelVersion } from '../types/model';
import { TableExtractionConfigState } from '../types/table';

export const mapTableConfigToState = ({
  modelVersion,
  entityId,
}: {
  modelVersion: ModelVersion;
  entityId: string;
}): TableExtractionConfigState => {
  const { config, scope } = modelVersion;
  return {
    input_type: 'evisort_document' as const,
    instructions: config.instructions,
    internal: config.internal ?? '',
    output_type: 'table_value' as const,
    prompt_model_type: 'table_extraction' as const,
    query: scope,
    tableSpecState: {
      key: entityId,
      name: config.table_spec.name ?? '',
      columns: config.table_spec.columns.map(mapTableColumnConfig),
    },
  };
};

export const testIsTableConfigDirty = ({
  activeQuery,
  config,
  originalConfig,
}: {
  activeQuery: SearchQuery;
  config: TableExtractionConfigState;
  originalConfig?: TableExtractionConfigState;
}) => {
  const activeConfig = { ...config, query: activeQuery };
  return originalConfig
    ? !isEqual(originalConfig, activeConfig)
    : Boolean(
        config.tableSpecState.name ||
        config.tableSpecState.columns.some(
          (column) => column.name || column.columnType || column.description,
        ) ||
        config.instructions ||
        (activeQuery && activeQuery.length > 0) ||
        config.internal,
      );
};
